export default "__VITE_ASSET__6M9td3YLx8eFPrYthtAXiA__"